// 관세사(customs_broker) 전용 포털 — 면장 처리 큐 조회 + 면장 업로드 (Wave 3.4, 2026-05-28)
//   백엔드: routes/clearanceBroker.js (GET /me, GET /queue, POST upload-myunjang, POST bulk-upload-myunjang)
//   CancelAgency 포털 미러 (단, 정산/업체관리 탭 없음 — Wave 5 보류).
import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import CustomsBrokerCompanies from './CustomsBrokerCompanies';
import CustomsBrokerSettlement from './CustomsBrokerSettlement';
import CustomsBrokerHistory from './CustomsBrokerHistory';
import CustomsBrokerUnmatched from './CustomsBrokerUnmatched';

var NAVY = '#1B3A5C';
var IMG_BASE = (API || '').replace(/\/api\/?$/, ''); // 쇼링 사진 공개 /uploads/<file> 서빙 (D5)

function CustomsBrokerPage({ showToast, user }) {
  var st = showToast || function () {};
  var meState = useState(null); var me = meState[0]; var setMe = meState[1];
  var tabState = useState('대기'); var tab = tabState[0]; var setTab = tabState[1];
  var itemsState = useState([]); var items = itemsState[0]; var setItems = itemsState[1];
  var loadingState = useState(false); var loading = loadingState[0]; var setLoading = loadingState[1];
  var uploadingState = useState(false); var uploading = uploadingState[0]; var setUploading = uploadingState[1];
  var dragState = useState(false); var dragOver = dragState[0]; var setDragOver = dragState[1];
  var resultsState = useState([]); var results = resultsState[0]; var setResults = resultsState[1];
  // 보완 요청(반려) 모달
  var revState = useState(null); var revModal = revState[0]; var setRevModal = revState[1]; // {id, carNo} | null
  var revCatState = useState('사진부족'); var revCategory = revCatState[0]; var setRevCategory = revCatState[1];
  var revMemoState = useState(''); var revMemo = revMemoState[0]; var setRevMemo = revMemoState[1];
  // 상단 뷰: upload(면장 업로드) | queue(처리 현황) | companies(관리 업체) | settlement(월정산) | history(정산 이력)
  var viewState = useState('upload'); var view = viewState[0]; var setView = viewState[1];
  var stlCidState = useState(0); var stlCompanyId = stlCidState[0]; var setStlCompanyId = stlCidState[1];
  // 통관 메시지 스레드 모달 (P2)
  var msgModalState = useState(null); var msgModal = msgModalState[0]; var setMsgModal = msgModalState[1]; // {id, carNo} | null
  var msgListState = useState([]); var msgList = msgListState[0]; var setMsgList = msgListState[1];
  var msgInputState = useState(''); var msgInput = msgInputState[0]; var setMsgInput = msgInputState[1];

  function loadMe() {
    authFetch(API + '/clearance-broker/me').then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.success) setMe(d);
    }).catch(function () {});
  }
  function loadQueue(status) {
    setLoading(true);
    authFetch(API + '/clearance-broker/queue?status=' + encodeURIComponent(status)).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.success) setItems(d.items || []);
      setLoading(false);
    }).catch(function () { setLoading(false); });
  }

  useEffect(function () { loadMe(); }, []);
  useEffect(function () { loadQueue(tab); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [tab]);

  // 통관 메시지 스레드 (P2) — 열기/작성
  function openMessages(it) { setMsgModal({ id: it.id, carNo: it.carNo }); setMsgInput(''); loadMessages(it.id); }
  function loadMessages(reqId) {
    authFetch(API + '/clearance-broker/requests/' + reqId + '/messages').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) setMsgList(d.messages || []); }).catch(function () {});
  }
  function postMsg() {
    if (!msgModal || !msgInput.trim()) return;
    authFetch(API + '/clearance-broker/requests/' + msgModal.id + '/messages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: msgInput }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { setMsgInput(''); loadMessages(msgModal.id); } else st((d && d.error) || '전송 실패', 'err'); })
      .catch(function () { st('전송 실패', 'err'); });
  }
  // 신고 처리중 — 대기 의뢰를 신고중으로 전환 + 업체 알림 (관세청 신고 접수 표시)
  function startFiling(it) {
    if (!window.confirm(it.carNo + ' — 통관 신고를 접수(처리중)로 표시할까요? 업체에 알림이 전송됩니다.')) return;
    authFetch(API + '/clearance-broker/requests/' + it.id + '/start-filing', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { st('신고중으로 전환 · 업체 알림 전송됨', ''); loadMe(); loadQueue(tab); }
        else st((d && d.error) || '전환 실패', 'err');
      }).catch(function () { st('전환 실패', 'err'); });
  }
  // 보완 요청 전송 — 대기 의뢰를 업체에 반려 (사진/정보 부족)
  function submitRevision() {
    if (!revModal) return;
    authFetch(API + '/clearance-broker/requests/' + revModal.id + '/request-revision', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ category: revCategory, memo: revMemo }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { st('보완 요청 전송됨', ''); setRevModal(null); setRevMemo(''); loadMe(); loadQueue(tab); }
        else st((d && d.error) || '보완 요청 실패', 'err');
      }).catch(function () { st('보완 요청 실패', 'err'); });
  }

  // 현재 탭 ref — 소켓 핸들러 stale closure 방지
  var tabRef = useRef(tab);
  useEffect(function () { tabRef.current = tab; }, [tab]);

  // 실시간 의뢰 도착 — 소켓 clearance:new-request (clearance:{agencyId} 룸, Wave1 join) → 재로그인 없이 즉시 갱신
  useEffect(function () {
    var sock = getSocket();
    if (!sock) return;
    function onNewRequest() { loadMe(); loadQueue(tabRef.current); st('🆕 새 면장 의뢰 도착', ''); }
    sock.on('clearance:new-request', onNewRequest);
    return function () { try { sock.off('clearance:new-request', onNewRequest); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function doUpload(fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    if (files.length === 0) return;
    setUploading(true); setResults([]);
    var single = files.length === 1;
    var fd = new FormData();
    if (single) { fd.append('file', files[0]); }
    else { files.forEach(function (f) { fd.append('files', f); }); }
    var url = single ? API + '/clearance-broker/upload-myunjang' : API + '/clearance-broker/bulk-upload-myunjang';
    authFetch(url, { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(function (d) {
      setUploading(false);
      if (d && d.error) { st(d.error, 'err'); return; }
      if (single) {
        if (d.matched) {
          st('✅ 면장 매칭 ' + d.totalMatched + '대 완료', '');
          setResults([{ file: '업로드 파일', matched: true, totalMatched: d.totalMatched, exportDecNo: d.exportDecNo }]);
        } else {
          st('매칭 실패: ' + (d.reason || ''), 'err');
          setResults([{ file: '업로드 파일', matched: false, reason: d.reason }]);
        }
      } else {
        st('✅ ' + (d.totalMatched || 0) + '대 면장완료 (' + (d.totalFiles || 0) + '개 파일)', '');
        setResults(d.results || []);
      }
      loadMe(); loadQueue(tab);
    }).catch(function () { setUploading(false); st('업로드 실패', 'err'); });
  }

  function onDrop(e) {
    e.preventDefault(); setDragOver(false);
    if (uploading) return;
    doUpload(e.dataTransfer.files);
  }
  function onFilePick(e) {
    doUpload(e.target.files);
    e.target.value = '';
  }

  // 보완 첨부 다운로드 공통 — authFetch→blob (JWT 필요 엔드포인트)
  function downloadBlob(path, name, errMsg) {
    authFetch(API + path)
      .then(function (r) { if (!r.ok) throw new Error('not ok'); return r.blob(); })
      .then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = name || 'file';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1000);
      }).catch(function () { st(errMsg || '다운로드 실패', 'err'); });
  }
  function downloadFile(fileId, name) { downloadBlob('/clearance-broker/files/' + fileId + '/download', name || 'file', '다운로드 실패'); }
  // 한 의뢰의 첨부파일 전체를 개별 파일로 순차 다운로드 (ZIP 압축해제 불필요). 브라우저 다중 다운로드 차단 회피 위해 stagger.
  //   ⚠️ 첫 회 '여러 파일 다운로드 허용?' 프롬프트 1회 → 허용 시 이후 자동.
  function downloadAll(it) {
    var files = (it && it.files) || [];
    if (files.length === 0) return;
    files.forEach(function (f, i) {
      setTimeout(function () { downloadFile(f.id, f.originalName); }, i * 600);
    });
  }
  // 신고용 인보이스 PDF 다운로드 (P0b) — 기존 /invoices/:id/pdf 재사용, 큐 스코프 권한. authFetch→blob.
  function downloadInvoice(it) {
    if (!it.invoiceId) return;
    downloadBlob('/invoices/' + it.invoiceId + '/pdf', 'invoice_' + it.invoiceId + '.pdf', '인보이스 생성 실패');
  }
  // 수출신고 준비자료 엑셀 (P3 A안) — 통관프로그램 입력 참고용
  function downloadDeclaration(it) {
    downloadBlob('/clearance-broker/requests/' + it.id + '/declaration-xlsx', '수출신고자료_' + (it.carNo || '') + '.xlsx', '신고자료 생성 실패');
  }

  var counts = (me && me.counts) || { '대기': 0, '완료': 0, total: 0 };
  var agencyName = (me && me.agency && me.agency.name) || (user && user.name) || '관세사';

  return (
    <div style={{ padding: 20, maxWidth: 1100, margin: '0 auto' }}>
      {/* 헤더 — 관세사명 + 카운트 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>{'📦 ' + agencyName}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{'수출면장 처리 포털'}</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 10, padding: '8px 16px', textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#9a3412' }}>{'대기'}</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#ea580c' }}>{counts['대기'] || 0}</div>
          </div>
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '8px 16px', textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#166534' }}>{'완료'}</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#16a34a' }}>{counts['완료'] || 0}</div>
          </div>
        </div>
      </div>

      {/* 상단 뷰 전환 — 면장 업로드 / 처리 현황 / 관리 업체 / 월정산 / 정산 이력 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 18, borderBottom: '2px solid #f1f5f9' }}>
        {[['upload', '📤 면장 업로드'], ['queue', '📋 처리 현황'], ['companies', '🏢 관리 업체'], ['settlement', '💰 월정산'], ['history', '📜 정산 이력']].map(function (v) {
          var active = view === v[0];
          return <button key={v[0]} onClick={function () { setView(v[0]); }} style={{ padding: '9px 18px', border: 'none', borderBottom: '3px solid ' + (active ? NAVY : 'transparent'), background: 'transparent', color: active ? NAVY : '#94a3b8', fontWeight: active ? 800 : 600, fontSize: 14, cursor: 'pointer', marginBottom: -2 }}>{v[1]}</button>;
        })}
      </div>

      {view === 'companies' && <CustomsBrokerCompanies showToast={st} goSettlement={function (cid) { setStlCompanyId(cid); setView('settlement'); }} />}
      {view === 'settlement' && <CustomsBrokerSettlement showToast={st} initialCompanyId={stlCompanyId} />}
      {view === 'history' && <CustomsBrokerHistory showToast={st} />}

      {view === 'upload' && (<React.Fragment>
      {/* 업로드 영역 — 드래그 배치 + 단일 */}
      <div
        onDragOver={function (e) { e.preventDefault(); setDragOver(true); }}
        onDragLeave={function () { setDragOver(false); }}
        onDrop={onDrop}
        style={{ border: '2px dashed ' + (dragOver ? NAVY : '#cbd5e1'), borderRadius: 12, padding: '24px 20px', textAlign: 'center', background: dragOver ? '#eff6ff' : '#f8fafc', marginBottom: 20, transition: 'all 0.15s' }}>
        <div style={{ fontSize: 32, opacity: 0.5 }}>{uploading ? '⏳' : '📄'}</div>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#334155', marginTop: 8 }}>
          {uploading ? '면장 OCR 처리 중...' : '수출면장(PDF/이미지)를 여기에 끌어놓거나 선택'}
        </div>
        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{'VIN 자동 매칭 → 면장완료 전환 + 의뢰 업체 알림. 멀티VIN PDF 1건으로 여러 차량 처리 가능.'}</div>
        <label style={{ display: 'inline-block', marginTop: 12, padding: '8px 20px', background: NAVY, color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.6 : 1 }}>
          {'파일 선택'}
          <input type="file" accept="image/*,.pdf" multiple disabled={uploading} onChange={onFilePick} style={{ display: 'none' }} />
        </label>
      </div>

      {/* 업로드 결과 */}
      {results.length > 0 && (
        <div style={{ marginBottom: 20, border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
          <div style={{ padding: '8px 14px', background: '#f1f5f9', fontSize: 12, fontWeight: 700, color: '#475569' }}>{'업로드 결과'}</div>
          {results.map(function (r, i) {
            return (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 14px', borderTop: '1px solid #f1f5f9', fontSize: 13 }}>
                <span style={{ color: '#334155' }}>{r.file}</span>
                {r.matched
                  ? <span style={{ color: '#16a34a', fontWeight: 700 }}>{'✅ ' + (r.totalMatched || 0) + '대' + (r.exportDecNo ? ' · ' + r.exportDecNo : '')}</span>
                  : <span style={{ color: '#dc2626', fontWeight: 600 }}>{'❌ ' + (r.reason || '매칭 실패')}</span>}
              </div>
            );
          })}
        </div>
      )}
      </React.Fragment>)}

      {view === 'queue' && (<React.Fragment>
      {/* 대기/신고중/완료/미매칭 하위 탭 */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
        {['대기', '신고중', '완료'].map(function (t) {
          var active = tab === t;
          var cnt = counts[t] || 0;
          return (
            <button key={t} onClick={function () { setTab(t); }}
              style={{ padding: '7px 18px', borderRadius: 8, border: '1px solid ' + (active ? NAVY : '#e5e7eb'), background: active ? NAVY : '#fff', color: active ? '#fff' : '#64748b', fontWeight: active ? 700 : 500, fontSize: 13, cursor: 'pointer' }}>
              {t + (cnt ? ' ' + cnt : '')}
            </button>
          );
        })}
        {(function () {
          var unN = (me && me.unmatched) || 0;
          var active = tab === '미매칭';
          return <button onClick={function () { setTab('미매칭'); }}
            style={{ padding: '7px 18px', borderRadius: 8, border: '1px solid ' + (active ? '#d97706' : (unN ? '#fde68a' : '#e5e7eb')), background: active ? '#d97706' : '#fff', color: active ? '#fff' : (unN ? '#b45309' : '#94a3b8'), fontWeight: active || unN ? 700 : 500, fontSize: 13, cursor: 'pointer' }}>
            {'⚠️ 미매칭' + (unN ? ' ' + unN : '')}</button>;
        })()}
      </div>

      {tab === '미매칭' ? <CustomsBrokerUnmatched showToast={st} onChange={function () { loadMe(); }} /> : (
      /* 큐 테이블 */
      <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden', background: '#fff' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8fafc', color: '#475569' }}>
              <th style={thS}>{'의뢰 업체'}</th>
              <th style={thS}>{'차종'}</th>
              <th style={thS}>{'차량번호'}</th>
              <th style={thS}>{'차대번호(VIN)'}</th>
              <th style={thS}>{'신고정보'}</th>
              <th style={thS}>{'신청일'}</th>
              {tab === '완료' && <th style={thS}>{'면장번호'}</th>}
              {tab === '완료' && <th style={thS}>{'완료일'}</th>}
              {tab !== '완료' && <th style={thS}>{'보완 첨부'}</th>}
              {tab !== '완료' && <th style={thS}>{'처리'}</th>}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={8} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{tab === '완료' ? '완료 내역이 없습니다' : (tab === '신고중' ? '신고중인 면장이 없습니다' : '대기 중인 면장이 없습니다')}</td></tr>}
            {!loading && items.map(function (it) {
              var hasFiles = it.files && it.files.length > 0;
              return (
                <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={tdS}>{it.companyName}</td>
                  <td style={tdS}>{it.carType}</td>
                  <td style={Object.assign({ fontWeight: 600 }, tdS)}>
                    {it.carNo}
                    {tab === '신고중' && <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, color: '#fff', background: '#2563eb', borderRadius: 8, padding: '1px 6px' }}>{'🛃 신고중'}</span>}
                    {tab !== '완료' && hasFiles && <span title="업체가 보완 후 재전송" style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, color: '#fff', background: '#16a34a', borderRadius: 8, padding: '1px 6px' }}>{'🔄 보완'}</span>}
                    {tab !== '완료' && it.dday !== null && it.dday !== undefined && <span title={'수출기한 ' + (it.exportDeadline || '')} style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, color: '#fff', background: it.dday <= 14 ? '#dc2626' : (it.dday <= 30 ? '#ea580c' : '#94a3b8'), borderRadius: 8, padding: '1px 6px' }}>{it.dday < 0 ? '기한초과' : 'D-' + it.dday}</span>}
                  </td>
                  <td style={Object.assign({ fontFamily: 'monospace', fontSize: 11, color: '#64748b' }, tdS)}>{it.vin}</td>
                  <td style={tdS}>
                    {it.consignee ? <div style={{ fontSize: 12, color: '#334155' }}>{'📦 ' + it.consignee}</div> : <span style={{ color: '#cbd5e1', fontSize: 11 }}>{'consignee -'}</span>}
                    {it.invoiceAmount > 0 && <div style={{ fontSize: 11, color: '#64748b' }}>{'신고 ₩' + it.invoiceAmount.toLocaleString('ko-KR')}</div>}
                    {it.invoiceAmount === 0 && it.sellPriceUsd > 0 && <div style={{ fontSize: 11, color: '#64748b' }}>{'$' + it.sellPriceUsd.toLocaleString('en-US')}</div>}
                    {it.invoiceId && <button onClick={function () { downloadInvoice(it); }} style={{ marginTop: 3, marginRight: 4, padding: '2px 8px', border: '1px solid #c7d2fe', background: '#eef2ff', color: '#4338ca', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{'📄 인보이스'}</button>}
                    {tab !== '완료' && <button onClick={function () { downloadDeclaration(it); }} style={{ marginTop: 3, marginRight: 4, padding: '2px 8px', border: '1px solid #bbf7d0', background: '#f0fdf4', color: '#15803d', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{'📋 신고자료'}</button>}
                    <button onClick={function () { openMessages(it); }} style={{ marginTop: 3, padding: '2px 8px', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{'💬 메시지'}</button>
                    {it.shoringPhotos && it.shoringPhotos.length > 0 && (
                      <div style={{ marginTop: 5, display: 'flex', gap: 4, flexWrap: 'wrap', alignItems: 'center' }}>
                        <span title="쇼링장이 올린 쇼링·면장용 사진" style={{ fontSize: 10, fontWeight: 700, color: '#15803d' }}>{'🏭 쇼링 ' + it.shoringPhotos.length}</span>
                        {it.shoringPhotos.slice(0, 8).map(function (p) {
                          return <a key={p.id} href={IMG_BASE + '/uploads/' + p.fileName} target="_blank" rel="noopener noreferrer">
                            <img src={IMG_BASE + '/uploads/' + p.fileName} alt="" style={{ width: 34, height: 34, objectFit: 'cover', borderRadius: 5, border: '1px solid #bbf7d0' }} />
                          </a>;
                        })}
                      </div>
                    )}
                  </td>
                  <td style={tdS}>{it.requestDate}</td>
                  {tab === '완료' && <td style={tdS}>{it.exportDecNo}</td>}
                  {tab === '완료' && <td style={tdS}>{it.completedDate}</td>}
                  {tab !== '완료' && <td style={tdS}>{hasFiles ? (<React.Fragment>
                    {it.files.length > 1 && <button onClick={function () { downloadAll(it); }} style={{ display: 'block', marginBottom: 5, padding: '4px 8px', border: 'none', background: '#1d4ed8', color: '#fff', borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>{'⬇️ 전체 다운로드 (' + it.files.length + ')'}</button>}
                    {it.files.map(function (f) {
                      return <button key={f.id} onClick={function () { downloadFile(f.id, f.originalName); }} title={f.originalName} style={{ display: 'block', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: 3, padding: '3px 8px', border: '1px solid #bfdbfe', background: '#eff6ff', color: '#1d4ed8', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>{'📎 ' + f.originalName}</button>;
                    })}
                  </React.Fragment>) : <span style={{ color: '#cbd5e1' }}>{'-'}</span>}</td>}
                  {tab !== '완료' && <td style={tdS}>
                    {tab === '대기' && <button onClick={function () { startFiling(it); }} style={{ display: 'block', marginBottom: 4, padding: '4px 10px', border: 'none', background: '#2563eb', color: '#fff', borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>{'🛃 신고 처리중'}</button>}
                    <button onClick={function () { setRevCategory('사진부족'); setRevMemo(''); setRevModal({ id: it.id, carNo: it.carNo }); }} style={{ padding: '4px 10px', border: '1px solid #fca5a5', background: '#fef2f2', color: '#dc2626', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{'보완 요청'}</button>
                  </td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      )}
      </React.Fragment>)}

      {/* 보완 요청 모달 */}
      {revModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={function () { setRevModal(null); }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 22, width: 400, maxWidth: '90vw' }} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'보완 요청'}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>{'차량 ' + (revModal.carNo || '') + ' — 업체에 보완 요청을 보냅니다 (의뢰는 보완요청 상태로).'}</div>
            <label style={{ fontSize: 12, color: '#475569', fontWeight: 600 }}>{'사유 분류'}</label>
            <select value={revCategory} onChange={function (e) { setRevCategory(e.target.value); }} style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13, margin: '4px 0 12px' }}>
              <option value="사진부족">{'사진 부족'}</option>
              <option value="정보부족">{'정보 부족'}</option>
              <option value="기타">{'기타'}</option>
            </select>
            <label style={{ fontSize: 12, color: '#475569', fontWeight: 600 }}>{'상세 메모'}</label>
            <textarea value={revMemo} onChange={function (e) { setRevMemo(e.target.value); }} placeholder="예: 앞면 사진 추가 / 차대번호 확인 필요" rows={3} style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13, margin: '4px 0 16px', resize: 'vertical', boxSizing: 'border-box' }} />
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={function () { setRevModal(null); }} style={{ flex: 1, padding: '10px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'취소'}</button>
              <button onClick={submitRevision} style={{ flex: 2, padding: '10px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'보완 요청 전송'}</button>
            </div>
          </div>
        </div>
      )}

      {/* 통관 메시지 스레드 모달 (P2) */}
      {msgModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={function () { setMsgModal(null); }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 20, width: 440, maxWidth: '92vw', display: 'flex', flexDirection: 'column', maxHeight: '80vh' }} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY, marginBottom: 2 }}>{'💬 통관 메시지'}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>{'차량 ' + (msgModal.carNo || '') + ' — 업체와 메모/문의를 주고받습니다.'}</div>
            <div style={{ flex: 1, overflowY: 'auto', background: '#f8fafc', borderRadius: 8, padding: 10, marginBottom: 10, minHeight: 120 }}>
              {msgList.length === 0 && <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, padding: 20 }}>{'아직 메시지가 없습니다'}</div>}
              {msgList.map(function (m) {
                var mine = m.sender === 'broker';
                return (
                  <div key={m.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start', marginBottom: 6 }}>
                    <div style={{ maxWidth: '78%', background: mine ? NAVY : '#fff', color: mine ? '#fff' : '#334155', border: mine ? 'none' : '1px solid #e5e7eb', borderRadius: 10, padding: '7px 11px' }}>
                      <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{m.body}</div>
                      <div style={{ fontSize: 10, color: mine ? '#cbd5e1' : '#94a3b8', marginTop: 3, textAlign: 'right' }}>{(mine ? '나(관세사)' : '업체') + ' · ' + (m.createdAt || '').slice(5, 16)}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <input value={msgInput} onChange={function (e) { setMsgInput(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') postMsg(); }} placeholder="메시지 입력 후 Enter" style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13, boxSizing: 'border-box' }} />
              <button onClick={postMsg} style={{ padding: '9px 16px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'전송'}</button>
            </div>
            <button onClick={function () { setMsgModal(null); }} style={{ marginTop: 8, padding: '8px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'닫기'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12, borderBottom: '1px solid #e5e7eb' };
var tdS = { padding: '9px 12px', color: '#334155' };

export default CustomsBrokerPage;
